import React, { Component } from 'react';

import {
  Container,
} from '../../../components';

import Logo from '../../../components/Logo';
import NavigationFooterMenu from '../../Menu/NavigationFooterMenu';
import NavigationCopyrightMenu from '../../Menu/NavigationCopyrightMenu';

import './style.scss';

class FooterFull extends Component {
  render() {
    const date = new Date();
    const currentYear = date.getFullYear();

    return (
      <div className="Footer o-background--grey">
        <Container className="Footer-container">
          <Logo small />
          <NavigationFooterMenu />
          <div className="Footer__bottom">
            © Werken bij HVC {currentYear}
            <NavigationCopyrightMenu />
          </div>
        </Container>
      </div>
    );
  }
}

export default FooterFull;
